import * as Sentry from '@sentry/browser';
import { FetchRateQuoteRequestAction } from '../rate-quote/actions';

export function* setRateQuoteContext({ payload }: FetchRateQuoteRequestAction): Generator<void> {
  Sentry.setContext('rate_quote', { rateQuoteId: payload.rateQuoteId });
}
